<template>
  <div class="login">
    <div style="width: 100%">
      <div class="login_title">
        <h2>登录</h2>
        <p>欢迎使用未来润美新零售商城</p>
      </div>
      <van-form @submit="onSubmit">
        <div class="login_check">
          <!-- 输入手机号，调起手机号键盘 -->
          <van-field
            :border="false"
            v-model="username"
            type="username"
            placeholder="请输入您的手机号"
            size="18px"
            name="username"
          />
          <!-- 输入密码 -->
          <van-field
            class="pass"
            :border="false"
            name="password"
            v-model="password"
            :type="eyeReShow ? 'password' : 'text'"
            placeholder="请输入您的密码"
            :right-icon="
              eyeReShow
                ? require('../../assets/img/login_password_invisible@2x.png')
                : require('../../assets/img/login_password_visible@2x.png')
            "
            @click-right-icon="eyeReShow = !eyeReShow"
            clearable
          />
        </div>
        <div class="login_button">
          <van-button round type="info" class="active" native-type="submit"
            >登录</van-button
          >
          <div class="weixin" @click="toWeiXi()">
            <img
              src="../../assets/img/login_icon_weixin@2x.png"
              alt=""
              style="width: 0.2rem; height: 0.17rem"
            />
            <p>微信快捷登录</p>
          </div>
        </div>
      </van-form>
      <div class="foot">
        <router-link to="/registered" class="toRegistered"
          >账号注册</router-link
        >
        <router-link to="/forgot" class="toForget">忘记密码？</router-link>
      </div>
    </div>
    <div class="privacy" @click="toPrivacy()">《隐私政策》</div>
  </div>
</template>

<script>
import Title from '../../components/Title'
import { getLogin, toWeiLogin, getUserInfo } from '../../api/home'
import { Toast } from 'vant'
export default {
  components: {
    Title
  },
  data () {
    return {
      username: '',
      password: '',
      sms: '',
      eyeReShow: true
    }
  },
  created () {
    if (window.location.href.split('code=')[1]) {
      const href = this.showWindowHref()
      this.code = href.code
      this.weixin()
    }
  },
  methods: {
    // 微信登录
    toWeiXi () {
      toWeiLogin({
        backurl: this.commonRealmName + '/h5/#/home?isLogin=1' // 要改
      })
        .then((res) => {
          if (res.data.code == 0) {
            window.location.href = res.data.backdata.loginurl
          } else {
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 获取url query 拼接 参数
    showWindowHref () {
      var sHref = window.location.href
      var args = sHref.split('?')
      if (args[0] == sHref) {
        return ''
      }
      var arr = args[1].split('&')
      var obj = {}
      for (var i = 0; i < arr.length; i++) {
        var arg = arr[i].split('=')
        obj[arg[0]] = arg[1]
      }
      return obj
    },
    // 微信绑定
    weixin () {
      weixinBind({
        code: this.code
      }).then((res) => { // 写个弹出框看看res看看哪里了
        Toast(JSON.stringify(res.data))
        if (res.data.msg == '微信未绑定') {
          sessionStorage.setItem('openid', res.data.backdata.openid)
          Toast('登陆后绑定手机号')
          this.$router.push('/login')
        } else {
          localStorage.setItem('userToken', res.data.backdata.token)
          getUserInfo().then((res) => {
            localStorage.setItem('aid', res.data.backdata.userinfo.id)
          })
        }
      })
    },
    toPrivacy () {
      this.$router.push({
        name: '文章详情',
        params: {
          id: 2,
          article: {
            title: '隐私政策'
          }
        }
      })
    },
    // 检测手机号的格式
    isvalidatemobile (phone) {
      const list = []
      let result = true
      let msg = ''
      var isPhone = /^1[3456789]\d{9}$/
      if (phone.length == 11) {
        if (!isPhone.test(phone)) {
          msg = '手机号码格式不正确'
          result = false
        }
      } else {
        msg = '手机号码长度不为11位'
        result = false
      }
      list.push(result)
      list.push(msg)
      return list
    },
    onSubmit (val) {
      if (this.password == '' || this.usernam == '') {
        Toast('用户名或密码不能为空')
      } else {
        // 判断手机号是否符合规范
        const validate = this.isvalidatemobile(this.username)
        if (validate[0]) {
          // if(sessionStorage.getItem('openid'))
          getLogin({
            password: this.password,
            username: this.username,
            openid: sessionStorage.getItem('openid')
          })
            .then((res) => {
              if (res.data.code == 0) {
                Toast(res.data.msg)
                localStorage.setItem('userToken', res.data.backdata.token)
                getUserInfo().then((res) => {
                  localStorage.setItem('aid', res.data.backdata.userinfo.id)
                })
                setTimeout(() => {
                  this.$router.push('/home')
                }, 1000)
              } else {
                Toast(res.data.msg)
              }
            })
            .catch((err) => {
              console.log(err)
              Toast('登录失败')
            })
        } else {
          Toast(validate[1])
        }
      }
    }
  }
}
</script>

<style lang="scss">
.login {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  background: url("../../assets/img/login_bg@2x.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  // 标题部分
  .login_title {
    width: 100%;
    height: 1.53rem;
    margin-bottom: 0.42rem;
    padding: 1.01rem 0.15rem 0 0.15rem;

    h2 {
      height: 0.23rem;
      font-size: 0.23rem;

      font-weight: bold;
      color: #93683d;
      line-height: 0.2rem;
      margin-bottom: 0.1rem;
    }

    p {
      font-size: 0.12rem;

      color: #999a9c;
      margin-left: 0.01rem;
    }
  }

  // 验证部分
  .login_check {
    padding: 0 0.15rem;

    .van-field {
      padding: 0px;
      width: 100%;
      height: 0.44rem;
      background: #ffffff;
      box-shadow: 0rem 0.05rem 0.1rem 0rem rgba(0, 83, 16, 0.04);
      border-radius: 0.08rem;
      margin-bottom: 0.22rem;

      .van-field__body {
        padding: 0 0.14rem;

        .van-field__button {
          .van-button--primary {
            background: linear-gradient(0deg, #d1ae79 0%, #f0d8b1 100%);
            border-radius: 8px;
            border: none;
            width: 0.93rem;
            height: 0.29rem;
            color: #93683d;
            font-size: 0.14rem;

            line-height: 0.2rem;
          }
        }

        .van-field__control {
          height: 0.44rem;
          line-height: 0.44rem;
          font-size: 0.14rem;
        }

        input::input-placeholder {
          color: #999a9c;
        }

        input::-webkit-input-placeholder {
          color: #999a9c;
        }

        input:-moz-placeholder {
          color: #999a9c;
        }

        input::-moz-placeholder {
          color: #999a9c;
        }

        input:-ms-input-placeholder {
          color: #999a9c;
        }
      }
    }
  }

  // 底部按钮部分
  .login_button {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 1.05rem;

    .van-button {
      width: 2.72rem;
      height: 0.44rem;
      margin-bottom: 0.19rem;
      border: none;
      font-size: 0.16rem;

      font-weight: bold;
      background: #999a9c;
      box-shadow: 0px 0.05rem 0.1rem 0rem rgba(0, 83, 16, 0.04);
      line-height: 0.2rem;

      margin-top: 0.22rem;

      &.active {
        color: #93683d !important;
        background: linear-gradient(0deg, #d1ae79 0%, #f0d8b1 100%);
      }
    }

    .weixin {
      display: flex;
      align-items: center;

      p {
        height: 0.2rem;
        margin-left: 0.08rem;
        font-size: 0.12rem;

        color: #999a9c;
        line-height: 0.2rem;
      }
    }
  }

  .foot {
    padding: 0.2rem 0.15rem 0 0.15rem;
    width: 100%;
    display: flex;
    justify-content: space-between;

    .toRegistered {
      font-size: 0.14rem;

      font-weight: bold;
      text-decoration: underline;
      color: #333333;
      line-height: 0.2rem;
      height: 0.2rem;
    }

    .toForget {
      height: 0.2rem;
      font-size: 0.14rem;

      font-weight: bold;
      color: #93683d;
      line-height: 0.2rem;
    }
  }

  .privacy {
    font-size: 0.12rem;
    width: 1rem;
    text-align: center;
    font-weight: bold;
    color: #93683d;
    // position: absolute;
    // left: 1.57rem;
    // bottom: 0.53rem;
    margin-bottom: 0.53rem;
  }
}
</style>
